export default {
  "ORn3dqSlP2": {
    "providerName": "RBAC",
    "buttonStringKey": "login.rbac.login-button",
    "titleStringKey": "login.rbac.staging.login-message"

  },
  "ldof8F2Ask": {
    "providerName": "RBACPROD",
    "buttonStringKey": "login.rbac.login-button",
    "titleStringKey": "login.rbac.login-message"
  }
}
